// extracted by mini-css-extract-plugin
export default {"tabContainer":"score_tabContainer__ztXxJ","tabs":"score_tabs__Yrc-K","tabItem":"score_tabItem__3cZbB"};